import * as React from "react";
import { forwardRef } from "react";
const SvgTextAlignCenter = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-text-align-center-icon lucide-text-align-center", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21 5H3" }), /* @__PURE__ */ React.createElement("path", { d: "M17 12H7" }), /* @__PURE__ */ React.createElement("path", { d: "M19 19H5" }));
const ForwardRef = forwardRef(SvgTextAlignCenter);
export { ForwardRef as ReactComponent };
